import React, { memo } from "react";
import { LayersControl, WMSTileLayer } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";

const MAP_CACHE = 'https://mapcache.terras.agr.br/mapcache_terras';

const MapCache = memo(({ position = 'topright' }) => {
  const layersToAdd = [
    {
      layers: 'municipios',
      label: 'Municípios',
      color: 'rgb(255,255,255)',
      opacity: 1,
    },
    {
      layers: 'terra_indigenas_banrisul',
      label: 'Terras Indigenas',
      color: '#ff8c00e4',
      opacity: 0.9,
    },
    {
      layers: 'terra_indigenas_za',
      label: 'Terras Indigenas - ZA',
      color: 'rgb(255,211,122)',
      opacity: 1,
    },
    {
      layers: 'uc_za',
      label: 'Unidades de Conservação - ZA',
      color: 'rgb(255,157,130)',
      opacity: 1,
    },
    {
      layers: 'ucm',
      label: 'Unidades de Conservação Municipal',
      color:'rgb(186,221,128)',
      opacity: 1,
    },
    {
      layers: 'uce',
      label: 'Unidades de Conservação Estadual',
      color: 'rgb(230,230,0)',
      opacity: 1,
    },
    {
      layers: 'ucf',
      label: 'Unidades de Conservação Federal',
      color: 'rgb(100,100,100)',
      opacity: 1,
    },
    {
      layers: 'uc_arie_banrisul',
      label: 'Unidades de Conservação ARIE',
      color: 'rgb(81, 135, 82)'
    },
    {
      layers: 'assentamentos',
      label: 'Incra: Assentamentos',
      color: 'rgb(200,154,8)',
      opacity: 1,
    },
    { 
      layers: 'icmbio_embargos_banrisul', 
      label: 'ICMBio: Embargos', 
      color: '#ffbf00e5', 
      opacity: 0.7,
    },
    { 
      layers: 'icmbio_embargos', 
      label: 'ICMBio: Embargos', 
      color: 'rgb(255, 131, 0)' 
    },
    {
      layers: 'quilombos_banrisul',
      label: 'Incra: Quilombos',
      color: '#ff8c00e4',
      opacity: 0.7,
    },
    {
      layers: 'ibama_embargos_banrisul',
      label: 'Ibama: Embargos',
      color: '#ffbf00e5',
      opacity: 0.9,
    },
    {
      layers: 'bioma',
      label: 'MMA: Bioma',
      color: 'rgb(255,255,255)',
      opacity: 1,
    },
    {
      layers: 'vegetacao',
      label: 'Vegetação',
      color: 'rgb(255,255,255)',
      opacity: 1,
    },
    { 
      layers: 'mapbiomas_alertas_banrisul', 
      label: 'MapBiomas Alertas',
      color: '#ff4646e5', 
      opacity: 0.9,
    },
    { 
      layers: 'sitio_arqueologico_buffer_banrisul', 
      label: 'Sítio Arqueológico',
      color: '#ff4646e5', 
      opacity: 0.7,
    },
    {
      layers: 'cnfp_tipo_b',
      label: 'Floresta tipo B',
      color: 'rgb(200,50,50)'
    },
    // {
    //   layers: 'prodes_pre_2014',
    //   label: 'INPE: Prodes 22/07/2008 até 2014',
    //   color: 'rgb(255,0,0)',
    //   opacity: 1, 
    // },
    // {
    //   layers: 'prodes_pos_2014',
    //   label: 'INPE: Prodes 2013 até 2019  ',
    //   color: 'rgb(255,0,0)',
    //   opacity: 1, 
    // },
    // {
    //   layers: 'embargos_estaduais',
    //   label: 'Embargo Estadual PA - LDI',
    //   color: 'rgb(240,240,240)',
    //   opacity: 1,// 
    // },
    // {
    //   layers: 'faixa_fronteira',
    //   label: 'Exército: Faixa Fronteira',
    //   color: 'rgb(255,255,255)',
    //   opacity: 1,// 
    // },
  ];

  return (
    <LayersControl position={position}>
      {layersToAdd.map(layer => (
        <LayersControl.Overlay 
          name={`<div style='background-color:${layer.color}' class='tiny-box'></div>${layer.label}`}
          key={layer.layers}
        >
          <WMSTileLayer 
            url={MAP_CACHE}
            layers={layer.layers}
            transparent={true}
            format="image/png"
            opacity={layer.opacity}
          />
        </LayersControl.Overlay>
      ))}
    </LayersControl>
  );
});

export default MapCache;
